import { Alert, AlertProps, ThemeOptions } from '@mui/material'
import { colors } from '../../tokens/colors'

export { Alert }

export type { AlertProps }

export const alertThemeOverrides: ThemeOptions['components'] = {
  MuiAlert: {
    styleOverrides: {
      standardSuccess: {
        backgroundColor: colors.feedback.successLight,
        color: colors.feedback.successDark,
      },
      standardError: {
        backgroundColor: colors.feedback.errorLight,
        color: colors.feedback.errorDark,
      },
      standardWarning: {
        backgroundColor: colors.feedback.warningLight,
        color: colors.feedback.warningDark,
      },
      standardInfo: {
        backgroundColor: colors.components.alert.info.background,
        color: colors.components.alert.info.type,
      },
    },
  },
}
